var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    overflow: "hidden",
    style: {
      position: "absolute",
      width: 0,
      height: 0
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-btn-1",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.927 32c-0.001 0-0.002 0-0.003 0-0.511 0-0.974-0.208-1.308-0.544l-0-0c-0.336-0.335-0.543-0.798-0.543-1.31s0.208-0.975 0.543-1.31l12.837-12.836-12.837-12.837c-0.724-0.724-0.724-1.897 0-2.62 0.724-0.724 1.897-0.724 2.621 0l14.146 14.146c0.724 0.724 0.724 1.897 0 2.62l-14.146 14.147c-0.334 0.336-0.796 0.544-1.307 0.544-0.001 0-0.002 0-0.003 0h0z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-card-arrow",
    viewBox: "0 0 55 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 3.4286,
    d: "M36.571 0c0 1.696 1.675 4.229 3.371 6.354 2.181 2.743 4.786 5.136 7.774 6.962 2.24 1.369 4.955 2.683 7.141 2.683M54.857 16c-2.185 0-4.903 1.314-7.141 2.683-2.987 1.829-5.593 4.222-7.774 6.96-1.696 2.128-3.371 4.665-3.371 6.357M54.857 16h-54.857"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-btn-2",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.073 0c0.001 0 0.002 0 0.003 0 0.511 0 0.974 0.208 1.308 0.544l0 0c0.336 0.335 0.543 0.798 0.543 1.31s-0.208 0.975-0.543 1.31l-12.837 12.836 12.837 12.837c0.724 0.724 0.724 1.897 0 2.62-0.724 0.724-1.897 0.724-2.621 0l-14.146-14.146c-0.724-0.724-0.724-1.897 0-2.62l14.146-14.147c0.334-0.336 0.796-0.544 1.308-0.544 0.001 0 0.002 0 0.003 0h-0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/icons.df0184f771dec66015131d64619255c5.svg";
export { ForwardRef as ReactComponent };